import { render, staticRenderFns } from "./rounded-button.vue?vue&type=template&id=48abe0b4&scoped=true&"
import script from "./rounded-button.vue?vue&type=script&lang=js&"
export * from "./rounded-button.vue?vue&type=script&lang=js&"
import style0 from "./rounded-button.vue?vue&type=style&index=0&id=48abe0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48abe0b4",
  null
  
)

export default component.exports